import { useCallback } from 'react';
import { useFeatureFlag } from '@ibk/shared-feature-flags';
import { FeatureFlagUseCase } from '@ibk/shared-types';
import { useGetPixKeysQuery, useGetPixKeysV2Query } from '../../services/pixKeysApi';
export function usePixKeys() {
    const { isFeatureFlagWhiteListed } = useFeatureFlag();
    const isV2Enabled = isFeatureFlagWhiteListed(FeatureFlagUseCase.CORE_BANKING_ENABLE_BAAS_V2);
    const queryOptions = { refetchOnMountOrArgChange: true };
    const queryV1 = useGetPixKeysQuery(undefined, { ...queryOptions, skip: isV2Enabled });
    const queryV2 = useGetPixKeysV2Query(undefined, { ...queryOptions, skip: !isV2Enabled });
    const pixKeysQuery = isV2Enabled ? queryV2 : queryV1;
    const pixKeys = pixKeysQuery.data?.result;
    const getPixKeys = useCallback(async () => {
        try {
            await pixKeysQuery.refetch();
        }
        catch {
        }
    }, []);
    return {
        loading: pixKeysQuery.isLoading,
        error: !!pixKeysQuery.error,
        pixKeys,
        getPixKeys,
    };
}
